import React, { useState } from "react";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";
import SortDropdown from "./SortDropdown";
import ViewToggle from "./ViewToggle";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { getAllProductsService } from "redux/services/general_service";

const ProductListHeader = ({
  totalProducts,
  currentSort,
  onSortChange,
  viewMode,
  onViewModeChange,
  onOpenFilters,
  searchQuery,
  selectedCategory,
  loading,
  handleSearch,
}) => {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const [searchInput, setSearchInput] = useState(""); // إذا لم يكن موجود

  const formatProductCount = (count) => {
    return count;
  };

  const getHeaderTitle = () => {
    if (searchQuery) {
      return `${t("searchResultsFor")} "${searchQuery}"`;
    }
    if (selectedCategory) {
      const categoryLabels = {
        electronics: t("electronics"),
        clothing: t("clothing"),
        home: t("home"),
        beauty: t("beauty"),
        sports: t("sports"),
        books: t("books"),
        toys: t("toys"),
        automotive: t("automotive"),
      };
      return categoryLabels[selectedCategory] || t("products");
    }
    return t("allProducts");
  };

  const getHeaderSubtitle = () => {
    if (loading) {
      return t("loadingProducts");
    }
    if (totalProducts === 0) {
      return t("noProductsFound");
    }
    if (totalProducts === 1) {
      return t("oneProductFound");
    }
    return `${formatProductCount(totalProducts)} ${t("productsFound")}`;
  };

return (
  <div className="bg-surface border-b border-border sticky top-16 z-40">
    <div className="max-w-7xl mx-auto px-4 py-5 space-y-5">

      {/* ================= TITLE ================= */}
      <div className="space-y-1">
        <h1 className="text-xl sm:text-2xl lg:text-3xl font-semibold text-text-primary">
          {getHeaderTitle()}
        </h1>
        <p className="text-sm sm:text-base text-text-secondary">
          {getHeaderSubtitle()}
        </p>
      </div>

      {/* ================= SEARCH ================= */}
      <div className="w-full">
        <div className="relative flex items-center bg-white border border-gray-300 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200">

          <input
            type="text"
            onChange={(e) => handleSearch(e.target.value)}
            placeholder="ابحث عن المنتجات..."
            className="w-full px-4 py-2.5 text-sm sm:text-base text-gray-700 placeholder-gray-400 rounded-l-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />

          <button
            onClick={() =>
              dispatch(getAllProductsService({ search: searchInput }))
            }
            className="px-4 py-2.5 bg-global-1 text-white rounded-r-lg hover:bg-blue-700 transition-colors duration-200 flex items-center justify-center"
          >
            <Icon name="Search" size={18} />
          </button>

        </div>
      </div>

      {/* ================= CONTROLS ================= */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">

        {/* LEFT SIDE */}
        <div className="flex items-center justify-between sm:justify-start gap-4">

          {/* Mobile Filter Button */}
          <Button
            variant="outline"
            size="sm"
            onClick={onOpenFilters}
            iconName="Filter"
            iconPosition="left"
            className="lg:hidden"
          >
            {t("filters")}
          </Button>

          {/* Results Count - Desktop */}
          <div className="hidden lg:flex items-center gap-2 text-sm text-text-secondary">
            <Icon name="Package" size={16} />
            <span>
              {loading
                ? t("loading")
                : `${formatProductCount(totalProducts)} ${t("results")}`}
            </span>
          </div>

        </div>

        {/* RIGHT SIDE */}
        <div className="flex items-center justify-between sm:justify-end gap-3 flex-wrap">

          {/* Sort */}
          <SortDropdown
            currentSort={currentSort}
            onSortChange={onSortChange}
          />

          {/* View Toggle - Desktop */}
          <div className="hidden md:block">
            <ViewToggle
              viewMode={viewMode}
              onViewModeChange={onViewModeChange}
            />
          </div>

        </div>
      </div>

      {/* ================= MOBILE VIEW TOGGLE =================
      <div className="md:hidden flex justify-center pt-2">
        <ViewToggle
          viewMode={viewMode}
          onViewModeChange={onViewModeChange}
        />
      </div> */}

    </div>
  </div>
);

};

export default ProductListHeader;
